module.exports = __webpack_public_path__ + "img/pintura.451b5f6e.jpg";